import { useEffect, useState } from 'react';

const NewYear2025 = () => {
  const [isPlayed, setIsPlayed] = useState(false);
  useEffect(() => {
    const videoElement = document.querySelector('video');
    videoElement.play();
  }, []);

  const play = () => {
    const videoElement = document.querySelector('video');
    if (videoElement) {
      videoElement.play();
      videoElement.muted = false;
      setIsPlayed(true);
    }
  };

  return (
    <div className="bg-[#ede5e3] h-screen flex items-center justify-center">
      <div className="container relative max-w-screen max-h-screen my-auto overflow-hidden flex items-center justify-center bg-pink-500">
        <div className="relative max-h-screen">
          <video className="w-full h-full max-h-screen aspect-[9/16]" src="https://weprodigi.com/uploads/images/newYear.mov" preload="auto"></video>
          {!isPlayed && (
            <div
              className="absolute bottom-[50%] right-[50%] translate-x-[50%] h-[60px] w-[60px] rounded-[50%] border border-white flex items-center justify-center cursor-pointer"
              onClick={play}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-[35px] w-[35px]"
                fill="white"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="white"
                onClick={play}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NewYear2025;
